import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SimposiosService } from '../../service/simposios.service';
import { Meta, Title } from '@angular/platform-browser';
import { Subscription } from 'rxjs';



@Component({
  selector: 'app-simposio',
  templateUrl: './simposio.component.html',
  styleUrls: ['./simposio.component.css']
})
export class SimposioComponent {
  private subcripcion:Subscription=new Subscription();

  simposio!: any;
  simposios!: any[];
  idnotshow: any;
  newstr: any;
  videook = false;

  //galeriaok : any;


  constructor(
    private _simposiosService : SimposiosService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private meta: Meta,
    private title: Title
  ){ 
    //cambios para que lea la nota
    this.title.setTitle(`Simposio | Fundación BEST`);
    this.meta.updateTag({ name: 'description', content: `Atención médica de calidad y calidez a toda la población mexicana Médicos titulados, altamente calificados, brindando consultas los 365 días del año.` }); 
    this.subcripcion.add(
      this.activatedRoute.params.subscribe(param => {
        this._simposiosService.getSimposios().subscribe((resp: any) =>{
            this.idnotshow = param['id']
            this.simposio = resp.find((simposio:any)=>simposio.id === parseInt(param['id']) );
            if(resp.video != null){
              this.videook = true;
            } 

        })

        /*Historico
        this._simposiosService.getSimposios().subscribe((resp2: any) => {
         this.notas = resp2.reverse().slice(3);
         })*/
      
      })

    );
    

  }

  allSimposios(){
    this.router.navigate(['simposios']);
  }


  ngOnInit(): void {
  }


}
